// ImageCarousel.js
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, EffectCoverflow, Autoplay } from 'swiper';
import 'swiper/swiper.min.css';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
import 'swiper/components/effect-coverflow/effect-coverflow.min.css';
import './ImageCarousel.css'; // Create this CSS file to customize the carousel appearance

// Install Swiper modules
SwiperCore.use([Navigation, Pagination, EffectCoverflow, Autoplay]);

// ImageCarousel.js
const ImageCarousel = () => {
  
    return (
      <Swiper
      effect={"coverflow"}
      grabCursor={true}
      centeredSlides={true}
      slidesPerView={"2"}
      autoplay={{
        delay: 2500,
        disableOnInteraction: false,
      }}
      coverflowEffect={{
        rotate: 50,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true,
      }}
      pagination={true}
      modules={[EffectCoverflow, Pagination]}
      loop={true}
      className="mySwiper"
    >
          <SwiperSlide>
            <img src="showcaseprev.jpeg" alt="Image 1" />
          </SwiperSlide>
          {localStorage.getItem('isSubscribed') === true || localStorage.getItem('isSubscribed') === "true" ? (
            <></>
            ) : (
            <SwiperSlide>
              <img src="superstreampremiumad.png" alt="Image 1" />
            </SwiperSlide>
            )}
          <SwiperSlide>
            <img src="socialframeprev.jpeg" alt="Image 2" />
          </SwiperSlide>
          <SwiperSlide>
            <img src="sc1.jpg" alt="Image 2" />
          </SwiperSlide>
          <SwiperSlide>
            <img src="superstreamad.png" alt="Image 2" />
          </SwiperSlide>
          <SwiperSlide>
            <img src="pronouncead.png" alt="advert for pronounce" />
          </SwiperSlide>
          {/* Add more SwiperSlides for each image you want to display */}
          <div className="swiper-button-prev"></div>
      <div className="swiper-button-next"></div>
        </Swiper>
      );
  };

export default ImageCarousel;
